/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import {
    GET_GATEWAY,
    GET_GATEWAY_ERROR,
    GET_GATEWAY_CAMPGROUNDS,
    GET_GATEWAY_CAMPGROUNDS_ERROR,
    GET_GATEWAY_PERMITS,
    GET_GATEWAY_PERMITS_ERROR,
    GET_GATEWAY_TICKETS,
    GET_GATEWAY_TICKETS_ERROR,
    GET_GATEWAY_DAYUSE,
    GET_GATEWAY_DAYUSE_ERROR,
    GET_GATEWAY_POINTS_OF_INTEREST,
    GET_GATEWAY_POINTS_OF_INTEREST_ERROR,
    GET_GATEWAY_SEARCH,
    GET_GATEWAY_SEARCH_ERROR,
    GET_POINT_OF_INTEREST,
    GET_POINT_OF_INTEREST_ERROR,
    GET_GATEWAY_ACTIVITY_PASSES,
    GET_GATEWAY_ACTIVITY_PASSES_ERROR,
    GET_GATEWAY_TREE_PERMITS,
    GET_GATEWAY_TREE_PERMITS_ERROR,
} from '../constants';

const INITIALSTATE = {
    gateway: { results: {} },
    campgrounds: { results: [] },
    permits: { results: [] },
    tickets: { results: [] },
    activities: { results: [] },
    activityPasses: { results: [] },
    otherFacilities: { results: [] },
    treePermits: { results: [] },
    search: { results: [] },
};

const gateway = (state = INITIALSTATE, action) => {
    const st = { ...state };
    switch (action.type) {
        case GET_GATEWAY:
            st.gateway = { results: action.payload, isValid: true };
            return st;
        case GET_GATEWAY_ERROR:
            st.gateway = { error: action.error, results: {}, isValid: false };
            return st;
        case GET_GATEWAY_CAMPGROUNDS:
            st.campgrounds = { results: action.payload, isValid: true };
            return st;
        case GET_GATEWAY_CAMPGROUNDS_ERROR:
            st.campgrounds = { error: action.error, results: [], isValid: false };
            return st;
        case GET_GATEWAY_PERMITS:
            st.permits = { results: action.payload, isValid: true };
            return st;
        case GET_GATEWAY_PERMITS_ERROR:
            st.permits = { error: action.error, results: [], isValid: false };
            return st;
        case GET_GATEWAY_TICKETS:
            st.tickets = { results: action.payload, isValid: true };
            return st;
        case GET_GATEWAY_TICKETS_ERROR:
            st.tickets = { error: action.error, results: [], isValid: false };
            return st;
        case GET_GATEWAY_DAYUSE:
            st.dayuse = { results: action.payload, isValid: true };
            return st;
        case GET_GATEWAY_DAYUSE_ERROR:
            st.dayuse = { error: action.error, results: [], isValid: false };
            return st;
        case GET_GATEWAY_POINTS_OF_INTEREST:
            st.otherFacilities = { results: action.payload, isValid: true };
            return st;
        case GET_GATEWAY_POINTS_OF_INTEREST_ERROR:
            st.otherFacilities = { error: action.error, results: [], isValid: false };
            return st;
        case GET_GATEWAY_SEARCH:
            st.search = { results: action.payload, isValid: true };
            return st;
        case GET_GATEWAY_SEARCH_ERROR:
            st.search = { error: action.error, results: [], isValid: false };
            return st;
        case GET_POINT_OF_INTEREST:
            st.pointOfInterest = { results: action.payload, isValid: true };
            return st;
        case GET_POINT_OF_INTEREST_ERROR:
            st.pointOfInterest = { error: action.error, results: [], isValid: false };
            return st;
        case GET_GATEWAY_ACTIVITY_PASSES:
            st.activityPasses = { results: action.payload, isValid: true };
            return st;
        case GET_GATEWAY_ACTIVITY_PASSES_ERROR:
            st.activityPasses = { error: action.error, results: [], isValid: false };
            return st;
        case GET_GATEWAY_TREE_PERMITS:
            st.treePermits = { results: action.payload, isValid: true };
            return st;
        case GET_GATEWAY_TREE_PERMITS_ERROR:
            st.treePermits = { error: action.error, results: [], isValid: false };
            return st;
        default:
            return st;
    }
};

export default gateway;
